import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SearchResult } from '../models';
import { BASE_URL } from '@teamfoster/sdk/ssr';

@Injectable({
  providedIn: 'root',
})
export class SearchResultsService {
  private http = inject(HttpClient);
  private BASE_URL = inject(BASE_URL, { optional: true });

  getSearchResults(q: string) {
    return this.http.get<SearchResult[]>(`${this.BASE_URL}api/search?q=${q}`);
  }
}
